// extracted by mini-css-extract-plugin
export var compact = "_n6-2";
export var phoneFrame = "_n6-0";
export var phoneScreen = "_n6-1";